import Vue from 'vue'
import Router from 'vue-router'
import views from '../views'
import my from './my'
import storeModule from './storeModule'
import luckDraw from './luckDraw'
Vue.use(Router);
export default new Router({
    //mode: 'history', //wx-jssdk在history模式下支持不好,所以改为#号模式
    routes: [{
        path: '/login/wx',
        name: 'wx-login',
        component: views.wxLogin,
        meta: {
            title:"加载中"
        }
    }, {
        path: '/login/psw',
        name: 'psw-login',
        component: views.pswLogin,
        meta: {
            requiresWxUser: true
        }
    }, {
        path: '/home/index',
        name: 'home-index',
        component: views.my.userCenter,
        meta: {
          login:true,
          requiresWxUser: true
        }
    },

].concat(my).concat(storeModule).concat(luckDraw)
})



// WEBPACK FOOTER //
// ./src/router/index.js